import { createRouter, createWebHistory } from 'vue-router'
import LoginView     from '@/views/LoginView.vue'
import DashboardView from '@/views/DashboardView.vue'
import TasksView     from '@/views/TasksView.vue'
import ProjectsView  from '@/views/ProjectsView.vue'
import ArchiveView   from '@/views/ArchiveView.vue'
import TeamView      from '@/views/TeamView.vue'
import TeamDirectoryView from '@/views/TeamDirectoryView.vue'
import RequestsView  from '@/views/RequestsView.vue'
import SearchView    from '@/views/SearchView.vue'
// Client portal (external clients only)
import ClientDashboard     from '@/views/client/ClientDashboard.vue'
import ClientProjects      from '@/views/client/ClientProjects.vue'
import ClientProjectDetail from '@/views/client/ClientProjectDetail.vue'
import ClientRequests      from '@/views/client/ClientRequests.vue'
import ClientReports       from '@/views/client/ClientReports.vue'

const routes = [
  { path: '/login',    name: 'login',     component: LoginView,     meta: { public: true } },

  // Internal (dev/manager) app
  { path: '/',         name: 'dashboard', component: DashboardView,    meta: { internalOnly: true } },
  { path: '/tasks',    name: 'tasks',     component: TasksView,        meta: { internalOnly: true } },
  { path: '/projects', name: 'projects',  component: ProjectsView,     meta: { internalOnly: true } },
  { path: '/team',     name: 'team',      component: TeamDirectoryView, meta: { internalOnly: true } },
  { path: '/archive',  name: 'archive',   component: ArchiveView,      meta: { internalOnly: true } },
  { path: '/clients',  name: 'clients',   component: TeamView,         meta: { internalOnly: true } },
  { path: '/requests', name: 'requests',  component: RequestsView,     meta: { internalOnly: true } },
  { path: '/search',   name: 'search',    component: SearchView,       meta: { internalOnly: true } },

  // Client portal
  { path: '/portal',           name: 'c-dashboard', component: ClientDashboard,     meta: { clientOnly: true } },
  { path: '/portal/projects',  name: 'c-projects',  component: ClientProjects,      meta: { clientOnly: true } },
  { path: '/portal/projects/:id', name: 'c-project', component: ClientProjectDetail, meta: { clientOnly: true } },
  { path: '/portal/requests',  name: 'c-requests',  component: ClientRequests,      meta: { clientOnly: true } },
  { path: '/portal/reports',   name: 'c-reports',   component: ClientReports,       meta: { clientOnly: true } },

  { path: '/:catchAll(.*)', redirect: '/' },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to) => {
  const token = localStorage.getItem('todo_token')
  const user  = JSON.parse(localStorage.getItem('todo_user') || 'null')
  const isExternal = user?.user_type === 'external'

  if (!to.meta.public && !token) {
    return { name: 'login' }
  }
  if (to.name === 'login' && token) {
    return isExternal ? { name: 'c-dashboard' } : { name: 'dashboard' }
  }
  // Keep the two apps separate: clients live under /portal, internal users don't.
  if (isExternal && !to.meta.public && !to.meta.clientOnly) {
    return { name: 'c-dashboard' }
  }
  if (!isExternal && token && to.meta.clientOnly) {
    return { name: 'dashboard' }
  }
  if (to.meta.managerOnly && user?.role !== 'manager') {
    return { name: 'dashboard' }
  }
})

export default router
